import { Icon } from '@iconify/react';

// Modal shell for the small yes/no decisions in this module. Rendering nothing
// when `open` is false lets callers mount it unconditionally and drive it from
// a single piece of state.
const TONES = {
    danger: 'tw-bg-rose-600 hover:tw-bg-rose-700',
    success: 'tw-bg-emerald-600 hover:tw-bg-emerald-700',
    primary: 'tw-bg-sky-600 hover:tw-bg-sky-700',
};

const ConfirmDialog = ({
    open,
    title,
    subtitle,
    children,
    confirmLabel = 'Confirm',
    busyLabel,
    cancelLabel = 'Cancel',
    tone = 'primary',
    icon,
    busy = false,
    onConfirm,
    onCancel,
}) => {
    if (!open) return null;

    return (
        <div className="tw-fixed tw-inset-0 tw-bg-black/40 tw-flex tw-items-center tw-justify-center tw-z-50 tw-p-4">
            <div className="tw-bg-white tw-rounded-xl tw-shadow-xl tw-w-full tw-max-w-sm tw-overflow-hidden">
                <div className="tw-p-4 tw-border-b tw-border-gray-100">
                    <h3 className="tw-mb-0 tw-text-sm tw-font-bold tw-text-gray-800">{title}</h3>
                    {subtitle && <p className="tw-mb-0 tw-text-[11px] tw-text-gray-500 tw-mt-0.5">{subtitle}</p>}
                </div>
                <div className="tw-p-5">
                    <div className="tw-text-xs tw-text-gray-600">{children}</div>
                    <div className="tw-flex tw-justify-end tw-gap-2 tw-mt-4">
                        <button
                            type="button"
                            onClick={onCancel}
                            className="tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-gray-600 tw-border tw-border-gray-200 tw-rounded-md hover:tw-bg-gray-50"
                        >
                            {cancelLabel}
                        </button>
                        <button
                            type="button"
                            onClick={onConfirm}
                            disabled={busy}
                            className={`tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-white tw-rounded-md disabled:tw-opacity-50 ${TONES[tone] || TONES.primary}`}
                        >
                            {icon && <Icon icon={icon} className="tw-text-sm" />}
                            {busy ? (busyLabel || 'Working...') : confirmLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
